export function RandomNumber (min, max) {
    return Math.random() * (max - min) + min
}